import { render, staticRenderFns } from "./PartPurchaseQualityControlDetailUpload.vue?vue&type=template&id=1035464c&"
import script from "./PartPurchaseQualityControlDetailUpload.vue?vue&type=script&lang=js&"
export * from "./PartPurchaseQualityControlDetailUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports